import { useMyTeamSuggestionsQuery } from "src/gql/codegen/duneGraphql";
import type { Session } from "src/utils/users/types";
import dunegql from "src/utils/dunegqlCodegen/dunegql";
import { logger } from "src/utils/logger/browser";

export function useTeamToJoin(session?: Session) {
  const { data } = useMyTeamSuggestionsQuery({
    skip: !session,
    context: { session },
    onError(error) {
      logger.error("Failed to fetch team suggestions", error);
    },
  });

  const teamToJoin = data?.teamSuggestions[0];

  return teamToJoin;
}

dunegql`
  query MyTeamSuggestions {
    teamSuggestions {
      id
      handle
      name
    }
  }
`;
